import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { AccountControl } from '../../../components/AccountControl/AccountControl.js';
import { useHeaderHandlers } from '../../../components/Header/context/index.js';
import { LoginControl } from '../../../components/LoginControl/LoginControl.js';
export const LoginControlWrapper = ({
  config,
  withCaption
}) => {
  const {
    onLoginClick,
    onLogoutClick
  } = useHeaderHandlers();
  return config?.pageType === 'book' ? _jsx(LoginControl, {
    onLoginClick: onLoginClick,
    onLogoutClick: onLogoutClick,
    hideLabelBreakpoint: withCaption ? undefined : 'lg'
  }, "AccountControl") : _jsx(AccountControl, {
    enableCaptionForAnonymous: withCaption
  });
};